<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeContractQuery.pageTitle') }}</div>
        <div class="figma-header-divider"></div>

        <!-- 筛选行：刷新 / 合同名称 / 合同编号 / 合同类型 / 搜索 -->
        <div class="figma-filter-row">
          <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
            <i class="el-icon-refresh-right"></i>
          </el-button>

          <div class="figma-search-group">
            <el-input v-model="conditions.contractName" size="small" placeholder="请输入合同名称" clearable class="figma-filter-control" />

            <el-input v-model="conditions.contractNo" size="small" placeholder="请输入合同编号" clearable class="figma-filter-control" />

            <el-select v-model="conditions.contractType" size="small" clearable filterable placeholder="请选择合同类型" class="figma-filter-control">
              <el-option v-for="t in contractTypeList" :key="t.id || t.typeId" :label="t.name || t.typeName" :value="t.id || t.typeId" />
            </el-select>

            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle" :loading="loading">
          <el-table-column prop="communityName" label="所在小区" min-width="120" show-overflow-tooltip />
          <el-table-column prop="contractCode" label="合同编号" min-width="130" show-overflow-tooltip />
          <el-table-column prop="parentContractCode" label="父合同编号" min-width="130" show-overflow-tooltip />
          <el-table-column prop="contractType" :label="$t('committeeContractQuery.table.contractType')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="operatorName" label="经办人" min-width="110" show-overflow-tooltip />
          <el-table-column prop="contractAmount" :label="$t('committeeContractQuery.table.contractAmount')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="partyB" :label="$t('committeeContractQuery.table.partyB')" min-width="120" show-overflow-tooltip />
          <el-table-column prop="partyA" :label="$t('committeeContractQuery.table.partyA')" min-width="120" show-overflow-tooltip />
          <el-table-column prop="createTime" :label="$t('committeeContractQuery.table.createTime')" min-width="150" show-overflow-tooltip />
          <el-table-column prop="validPeriod" label="有效期" min-width="150">
            <template slot-scope="scope">
              <span>{{ (scope.row.startTime || '-') + ' ~ ' + (scope.row.endTime || '-') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" :label="$t('committeeContractQuery.table.state')" min-width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.state==='PENDING' || scope.row.state===0" type="warning" effect="plain">待审核</el-tag>
              <el-tag v-else-if="scope.row.state==='APPROVED' || scope.row.state===1" type="primary" effect="plain">审核通过</el-tag>
              <el-tag v-else effect="plain">{{ scope.row.state || '-' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('committeeContractQuery.table.action')" width="260" align="center">
            <template slot-scope="scope">
              <div class="action-links" style="white-space: nowrap;">
                <el-button type="text" size="small" @click="handleDetail(scope.row)">查看</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="handleBusinessAccept(scope.row)">业务受理</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="handlePrint(scope.row)">打印</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color:#F56C6C">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="pagination.total" :current-page="pagination.page" :page-size="pagination.row" :page-sizes="[10, 20, 50]" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { queryContract, queryContractType, deleteContract } from '@/api/contract/contractManageApi'

export default {
  name: 'CommitteeContractQueryList',
  data() {
    return {
      loading: false,
      conditions: {
        keyword: '',
        contractName: '',
        contractNo: '',
        contractType: ''
      },
      tableData: [],
      pagination: { total: 0, page: 1, row: 10 },
      contractTypeList: [],
      communityList: []
    }
  },
  created() { this.initPage() },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 400, fontSize: '14px' } },
    cellStyle() { return { fontSize: '14px' } },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      return []
    },
    getTotal(res, list) { return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0) },
    async initPage() {
      await this.loadCommunities()
      this.loadContractTypes()
      this.getList()
    },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.communityList = res.data || []
      } catch (e) {
        this.communityList = []
      }
    },
    buildQueryParams() {
      return {
        page: this.pagination.page,
        row: this.pagination.row,
        keyword: this.conditions.keyword,
        communityIds: this.communityList.map(c => c.communityId).join(','),
        contractName: this.conditions.contractName,
        contractCode: this.conditions.contractNo,
        contractType: this.conditions.contractType
      }
    },
    async getList() {
      try {
        this.loading = true
        const res = await queryContract(this.buildQueryParams())
        const list = this.getListArray(res)
        this.tableData = list
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error('获取合同列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleDetail(row) {
      const contractId = row.contractId || row.id
      if (!contractId) {
        this.$message.error('缺少合同ID，无法查看')
        return
      }
      this.$router.push({
        path: '/views/contract/contractDetail',
        query: {
          contractId,
          source: 'contractQuery',
          currentTab: 'contractDetailRoom'
        }
      })
    },
    handleBusinessAccept(row) {
      const contractId = row.contractId || row.id
      if (!contractId) {
        this.$message.error('缺少合同ID')
        return
      }
      this.$router.push({
        path: `/views/contract/contractQueryDetail/${contractId}`,
        query: { source: 'contractQuery' }
      })
    },
    handlePrint(row) {
      const contractId = row.contractId || row.id
      if (!contractId) {
        this.$message.error('缺少合同ID，无法打印')
        return
      }
      window.open(`/#/views/contract/printContract?contractTypeId=${row.contractType || row.contractTypeId || ''}&contractId=${contractId}`)
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该合同？', '请确认您的操作', { type: 'warning' })
        await deleteContract({ id: row.id || row.contractId })
        this.$message.success('删除成功')
        this.getList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.message || '删除失败')
      }
    },
    async loadContractTypes() {
      try {
        const res = await queryContractType({ page: 1, row: 200 })
        this.contractTypeList = res.data || []
      } catch (e) {
        this.contractTypeList = []
      }
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.admin-room-container { padding: 20px; height: 100%; box-sizing: border-box; }
.figma-white-card { background: white; border-radius: 12px; padding: 20px 24px; height: 100%; display: flex; flex-direction: column; }
.figma-page-header { flex-shrink: 0; text-align: left; }
.figma-page-title { display: inline-block; font-size: 16px; font-weight: 600; color: #1D2129; margin: 0 0 12px 0; text-align: left; }
.figma-header-divider { height: 1px; background: #EBF2FA; margin-bottom: 12px; }
.figma-filter-row { display: flex; align-items: center; justify-content: space-between; }
.figma-search-group { display: flex; align-items: center; gap: 12px; }
.figma-filter-control { width: 256px; }
.figma-filter-control >>> .el-input__inner,
.figma-filter-control >>> .el-input--small .el-input__inner,
.figma-filter-control >>> .el-select .el-input__inner {
  height: 38px;
  line-height: 38px;
  border-radius: 10px;
  border: 1px solid #DCE6F5;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  color: #1D2129;
  background: #fff;
  padding: 0 16px;
}
.figma-filter-control >>> .el-input__inner::placeholder {
  color: #8C9BB4;
  font-size: 14px;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
}
.figma-filter-control >>> .el-select .el-input .el-select__caret {
  color: #364153;
}
.figma-btn-refresh {
  width: 38px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #fff !important;
  border: 1px solid #DCE6F5 !important;
  color: #364153 !important;
  border-radius: 10px !important;
}
.figma-btn-search {
  width: 84px !important;
  height: 38px !important;
  padding: 0 !important;
  background: #fff !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-family: Inter, PingFang SC, Microsoft YaHei, sans-serif;
  font-weight: 500 !important;
}
.figma-btn-search >>> i {
  margin-right: 4px;
}
.figma-table-section { flex: 1; margin-top: 12px; overflow: auto; }
.figma-pagination-section { display: flex; justify-content: flex-end; padding-top: 16px; flex-shrink: 0; }
.action-links { display: inline-flex; align-items: center; gap: 8px; color: #0E76FF; }
</style>
